export const CROP_STAGES = ['growth', 'production', 'prune'] as const;

export type CropStage = (typeof CROP_STAGES)[number];

export const CROP_STAGE_LABELS: Record<CropStage, string> = {
	growth: 'Crescimento',
	production: 'Produção',
	prune: 'Recepa',
};

export const CROP_STAGE_DESCRIPTIONS: Record<CropStage, string> = {
	growth: 'Fase de crescimento e desenvolvimento da planta',
	production: 'Fase produtiva com formação de frutos',
	prune: 'Fase de recepa e renovação da lavoura',
};
